"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BuildingsMultipleOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_BuildingsMultipleOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 3H6v2h1V3ZM10 3H9v2h1V3ZM7 8H6V6h1v2ZM10 8H9V6h1v2ZM6 11V9h1v2H6ZM9 11V9h1v2H9ZM13 9v1h1V9h-1ZM13 11v1h1v-1h-1ZM13 14v-1h1v1h-1ZM2 10V9h1v1H2ZM2 7v1h1V7H2ZM2 12v-1h1v1H2ZM2 13v1h1v-1H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2H3a2 2 0 0 0-2 2v.268A2 2 0 0 0 0 6v10h16V8a2 2 0 0 0-1-1.732V4a2 2 0 0 0-2-2h-1Zm-2-1H6a1 1 0 0 0-1 1v13h1v-3h4v3h1V2a1 1 0 0 0-1-1Zm2 2v3h2V4a1 1 0 0 0-1-1h-1Zm2 4h-2v8h3V8a1 1 0 0 0-1-1ZM3 3h1v1H2a1 1 0 0 1 1-1ZM1 6a1 1 0 0 1 1-1h2v10H1V6Zm8 9H7v-2h2v2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_BuildingsMultipleOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = BuildingsMultipleOutline;
exports["default"] = _default;